const config = Object.freeze({
  api: {
    baseUrl: process.env.REACT_APP_API_URL
  },
  msal: {
    auth: {
      clientId: '0e23c66a-ca4a-4952-9057-d83de57ce902'
    },
    cache: {
      // localStorage persists tokens across Office app WebViews (Excel, Word, etc.
      // each run in their own WebView process). sessionStorage would require the
      // user to log in separately in each app.
      cacheLocation: 'localStorage'
    },
    system: {
      // Only allow redirect inside an iframe (Office Online embeds the add-in
      // in an iframe and needs this). In a plain browser or desktop Office the
      // setting must be false, otherwise MSAL's iframe auth flow triggers
      // cross-site storage access that modern browsers block.
      allowRedirectInIframe: window.self !== window.top
    }
  },
  outlook: {
    readRetryCount: 30,
    readRetryTimeout: 2000
  },
  // Try Word host-native document handoff before protocol-based open.
  // This attempts to open the SharePoint document and close current doc via Word API.
  postSaveTryWordHostHandoff: true,
  // If false, Word will not use protocol-based fallback when host-native handoff fails.
  // This avoids external-protocol open prompts but may require manual reopen in rare cases.
  postSaveWordProtocolFallback: false,
  // Tag Office documents to auto-open this task pane when reopened.
  enablePostSaveAutoOpenTaskPane: true,
  autoLoginTimeout: 200,
  errorTimeout: 7000,
  waitForSaveTimeout: 5000
})

export default config
